var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99935 10.6667C8.73574 10.6667 9.33268 11.2637 9.33268 12C9.33268 12.7364 8.73574 13.3334 7.99935 13.3334C7.26296 13.3334 6.66602 12.7364 6.66602 12C6.66602 11.2637 7.26296 10.6667 7.99935 10.6667ZM7.99935 6.66671C8.73574 6.66671 9.33268 7.26365 9.33268 8.00004C9.33268 8.73643 8.73574 9.33337 7.99935 9.33337C7.26296 9.33337 6.66602 8.73643 6.66602 8.00004C6.66602 7.26365 7.26296 6.66671 7.99935 6.66671ZM9.33268 4.00004C9.33268 3.26365 8.73574 2.66671 7.99935 2.66671C7.26296 2.66671 6.66602 3.26365 6.66602 4.00004C6.66602 4.73643 7.26296 5.33337 7.99935 5.33337C8.73574 5.33337 9.33268 4.73643 9.33268 4.00004Z",
    fill: "#3E405F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoints);
export default __webpack_public_path__ + "static/media/Points.e9dfb4f60301f45132c8e27eb708c688.svg";
export { ForwardRef as ReactComponent };